import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MODULE_ROUTES, getModuleDisplayName } from '../../models/module-dependencies.const';

/** Cadastro de quem informa um CPF novo no totem (OE-1876). Só o celular é opcional. */
export interface ISetupRegistration {
  enabled: boolean;
  phone: boolean;
}

/** Setup sem o bloco: cadastro completo, como antes da OE-1876. */
export const DEFAULT_REGISTRATION: Readonly<ISetupRegistration> = { enabled: true, phone: true };

// Módulos do app que pedem idade e sexo no início quando a sessão é anônima.
const AGE_GENDER_MODULE_ROUTES: string[] = [MODULE_ROUTES.DR_OLIVE, MODULE_ROUTES.TRIAGE, MODULE_ROUTES.QUESTIONNAIRE];

export function createRegistrationGroup(): UntypedFormGroup {
  return new UntypedFormGroup({
    enabled: new UntypedFormControl(DEFAULT_REGISTRATION.enabled),
    phone: new UntypedFormControl(DEFAULT_REGISTRATION.phone)
  });
}

/** O JSON vem da API: só `false` explícito desliga uma tela. */
export function registrationFromConfig(
  config?: { registration?: Partial<ISetupRegistration> | null } | null
): ISetupRegistration {
  const registration = config?.registration;
  if (!registration || typeof registration !== 'object') {
    return { ...DEFAULT_REGISTRATION };
  }
  return { enabled: registration.enabled !== false, phone: registration.phone !== false };
}

export function getAgeGenderModuleNames(modules: { route: string; name: string }[]): string[] {
  return modules.filter((m) => AGE_GENDER_MODULE_ROUTES.includes(m.route)).map(getModuleDisplayName);
}
